/** Do not edit directly **/
/** Do not edit directly **/
/**
 * @prop --sy-backdrop-background-color: Backdrop background color.
 * @prop --sy-backdrop-top: Backdrop top.
 * @prop --sy-backdrop-right: Backdrop right.
 * @prop --sy-backdrop-left: Backdrop left.
 * @prop --sy-backdrop-bottom: Backdrop bottom.
 */
*,
:host,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  position: fixed;
  top: var(--sy-backdrop-top, 0);
  right: var(--sy-backdrop-right, 0);
  bottom: var(--sy-backdrop-bottom, 0);
  left: var(--sy-backdrop-left, 0);
  z-index: 1040;
  overflow-y: auto;
  background-color: var(--sy-backdrop-background-color, rgba(0, 0, 0, 0.6));
}